export default function addPublicAuthTokenHeader(config, publicAuthToken) {
  if (!config.headers) {
    config.headers = {}
  }
  config.headers['CRM-Canis-View-Authorization'] = `JWT ${publicAuthToken}`
  return config
}
